var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 21c-4.98 0-9-4.029-9-9 0-4.98 4.029-9 9-9a9 9 0 0 1 9 9 9 9 0 0 1-9 9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M11.25 13.25a.75.75 0 0 0 1.5 0h-1.5Zm1.76-1.85.416.624.012-.008-.428-.616ZM9.24 9.83a.75.75 0 1 0 1.5 0h-1.5Zm2.759 6.92a.75.75 0 0 0 0-1.5v1.5Zm-.01-1.5a.75.75 0 0 0 0 1.5v-1.5Zm.761-2V13h-1.5v.25h1.5Zm0-.25c0-.427.219-.671.676-.976l-.832-1.248c-.563.375-1.344 1.01-1.344 2.224h1.5Zm.688-.984c.531-.369 1.302-.994 1.302-2.186h-1.5c0 .408-.209.643-.658.954l.856 1.232ZM14.74 9.83a2.75 2.75 0 0 0-2.75-2.75v1.5c.688 0 1.25.557 1.25 1.25h1.5Zm-2.75-2.75a2.743 2.743 0 0 0-2.75 2.75h1.5c0-.696.554-1.25 1.25-1.25v-1.5Zm.009 8.17c-.554 0-1 .446-1 1h1.5c0 .274-.226.5-.5.5v-1.5Zm-1 1c0 .525.426 1 1 1v-1.5c.293 0 .5.235.5.5h-1.5Zm1 1a1 1 0 0 0 .704-.296A1 1 0 0 0 13 16.25h-1.5c0-.165.073-.286.143-.357A.5.5 0 0 1 12 15.75v1.5Zm1-1c0-.592-.495-1-1.01-1v1.5a.494.494 0 0 1-.49-.5h1.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export default ForwardRef;